import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id DD9AE6D3-6DF8-4CBC-A40F-CA25E4E6B310
 * name printer-pos-minus-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-minus-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPosMinusOutlineIcon = createSvgIcon(<><path d="M6 12H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V12C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H13C13 18.3 13.13 17.63 13.35 17H6V12M9 6H15V10H9V6M7 15V13H11V15H7M23 18V20H15V18H23Z" /></>, 'PrinterPosMinusOutlineIcon');
export default PrinterPosMinusOutlineIcon